"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, switchMap, catchError, map, mergeAll } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvPrizePotConstants } from "../_constants/lcvPrizePot.constants";
import {
     lcvPrizePotGetRequest,
     lcvPrizePotGetComplete,
     lcvPrizePotSetAvailabilityComplete,
     lcvPrizePotIncreaseQuantityComplete,
     lcvPrizePotGetBudgetActivityRequest,
     lcvPrizePotGetBudgetActivityComplete,
     lcvPrizePotAddBudgetEntryComplete,
} from "../_actions/lcvPrizePot.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";
import { withLcvCampaign } from "./lcvCampaign.epic";

// Reads use switchMap so a newer request wins; writes use mergeMap so they are never cancelled.
const post = (url, action, complete, operator, state$) =>
     operator((incoming) =>
          ajax
               .post(url, withLcvCampaign(incoming.payload, state$), getRequestHeader(requestTypes.REQUEST_TYPE_POST))
               .pipe(
                    map((ajaxResponse) => complete(ajaxResponse.response)),
                    catchError((error) => of(ajaxError(error))),
               ),
     );

// A write answers with a message and no data, so what it changed is read back rather than patched
// from the response. The reload is emitted here rather than from an effect on the screen, because
// the screen would then have to notice a message it may already be showing to know that something
// happened. Which reloads follow is passed in, since raising the budget changes the history while
// adding stock changes both the pot and the history.
const postThenReload = (url, complete, reloads, state$) =>
     mergeMap((incoming) =>
          ajax
               .post(url, withLcvCampaign(incoming.payload, state$), getRequestHeader(requestTypes.REQUEST_TYPE_POST))
               .pipe(
                    map((ajaxResponse) => of(complete(ajaxResponse.response), ...reloads.map((reload) => reload({})))),
                    catchError((error) => of(of(ajaxError(error)))),
                    mergeAll(),
               ),
     );

export const lcvPrizePotGetEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvPrizePotConstants.LCV_PRIZE_POT_GET_REQUEST),
          post("/api/lcvPrizePot/getPrizePot", null, lcvPrizePotGetComplete, switchMap, state$),
     );
};

export const lcvPrizePotSetAvailabilityEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvPrizePotConstants.LCV_PRIZE_POT_SET_AVAILABILITY_REQUEST),
          postThenReload("/api/lcvPrizePot/setPrizeAvailability", lcvPrizePotSetAvailabilityComplete, [
               lcvPrizePotGetRequest,
          ], state$),
     );
};

export const lcvPrizePotIncreaseQuantityEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvPrizePotConstants.LCV_PRIZE_POT_INCREASE_QUANTITY_REQUEST),
          postThenReload("/api/lcvPrizePot/increasePrizeQuantity", lcvPrizePotIncreaseQuantityComplete, [
               lcvPrizePotGetRequest,
               lcvPrizePotGetBudgetActivityRequest,
          ], state$),
     );
};

export const lcvPrizePotAddBudgetEntryEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvPrizePotConstants.LCV_PRIZE_POT_ADD_BUDGET_ENTRY_REQUEST),
          postThenReload("/api/lcvPrizePot/addBudgetEntry", lcvPrizePotAddBudgetEntryComplete, [
               lcvPrizePotGetBudgetActivityRequest,
          ], state$),
     );
};

export const lcvPrizePotGetBudgetActivityEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvPrizePotConstants.LCV_PRIZE_POT_GET_BUDGET_ACTIVITY_REQUEST),
          post("/api/lcvPrizePot/getBudgetActivity", null, lcvPrizePotGetBudgetActivityComplete, switchMap, state$),
     );
};
